export const WEBKIT_MESSAGE_HANDLER_NAME = 'LMND_EVENT';

export function postWebKitMessage(message: string): void {
  if (message === '' || typeof window === 'undefined') return;

  window.webkit?.messageHandlers?.[WEBKIT_MESSAGE_HANDLER_NAME].postMessage(message);
}

export function isNativeIOS(): boolean {
  return typeof window !== 'undefined' && window.webkit?.messageHandlers?.[WEBKIT_MESSAGE_HANDLER_NAME] != null;
}
